import axios from 'axios'

export default {
  state: () => ({
    specialists: [],
    meta: {}
  }),

  getters: {},

  mutations: {
    UPDATE_SPECIALISTS(state, specialists) {
      state.specialists.push(...specialists);
    },

    UPDATE_META(state, meta) {
      state.meta = meta
    }
  },

  actions: {
    GetSpecialists({ commit }, { data }) {
      return new Promise((resolve, reject) => {
        axios.get('/wp-json/wp/v2/doctors?_embed=wp:term,wp:featuredmedia&_fields=id,title,excerpt,link,_links,_embedded', {
          params: {
            ...data
          }
        })
          .then((response) => {
            commit('UPDATE_SPECIALISTS', response.data);

            commit('UPDATE_META', {
              totals: response.headers['x-wp-total'],
              pages: response.headers['x-wp-totalpages']
            });
            resolve();
          })
          .catch((e) => {
            resolve(e.response);
          });
      });
    }
  }
};
